import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Polygon, Popup, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

// Estilos CSS para mejorar los popups de Leaflet
const mapStyles = `
  .leaflet-popup-content-wrapper {
    background: #1e293b !important;
    border-radius: 0.5rem !important;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5) !important;
    border: 2px solid rgba(239, 68, 68, 0.5) !important;
  }
  
  .leaflet-popup-content {
    margin: 0 !important;
    color: #f1f5f9 !important;
    font-family: system-ui, -apple-system, sans-serif !important;
    font-weight: 500 !important;
  }
  
  .leaflet-popup-tip {
    background: #1e293b !important;
    border: 2px solid rgba(239, 68, 68, 0.5) !important;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3) !important;
  }
  
  .leaflet-popup-close-button {
    color: #f1f5f9 !important;
    font-size: 18px !important;
    font-weight: bold !important;
    padding: 4px 8px !important;
  }
  
  .leaflet-popup-close-button:hover {
    color: #ef4444 !important;
    background: rgba(239, 68, 68, 0.1) !important;
    border-radius: 0.25rem !important;
  }
`;

// Inyectar estilos
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement('style');
  styleSheet.type = 'text/css';
  styleSheet.innerText = mapStyles;
  document.head.appendChild(styleSheet);
}

const SetViewOnLoad = ({ center, zoom }) => {
  const map = useMap();
  useEffect(() => {
    map.setView(center, zoom);
  }, [map, center, zoom]);
  return null;
};

const HeartlandMap = () => {
  // Heartland (Rusia y Asia Central)
  const heartlandCoords = [
    [70, 30], [70, 100], [40, 100], [35, 60], [40, 30]
  ];

  // Europa del Este (la puerta al Heartland)
  const easternEuropeCoords = [
    [60, 15], [60, 30], [45, 30], [45, 15]
  ];

  return (
    <div style={{ height: '450px', width: '100%', borderRadius: '1rem', overflow: 'hidden', border: '2px solid rgba(239, 68, 68, 0.3)' }}>
      <MapContainer
        center={[55, 50]}
        zoom={3}
        style={{ height: '100%', width: '100%' }}
        scrollWheelZoom={false}
      >
        <SetViewOnLoad center={[55, 50]} zoom={3} />
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>'
          url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
        />
        
        {/* Heartland */}
        <Polygon
          positions={heartlandCoords}
          pathOptions={{ 
            color: '#ef4444', 
            fillColor: '#ef4444', 
            fillOpacity: 0.4,
            weight: 4
          }}
        >
          <Popup>
            <div style={{ 
              padding: '1rem', 
              background: '#1e293b', 
              borderRadius: '0.5rem',
              border: '2px solid #ef4444',
              minWidth: '250px'
            }}>
              <h3 style={{ 
                margin: 0, 
                marginBottom: '0.75rem', 
                color: '#ef4444',
                fontSize: '1.1rem',
                fontWeight: 'bold'
              }}>
                🔴 Heartland
              </h3>
              <p style={{ 
                margin: 0, 
                fontSize: '1rem',
                color: '#f1f5f9',
                fontWeight: '500',
                lineHeight: '1.4'
              }}>
                <strong>Zona Pivote de Mackinder</strong>
              </p>
              <p style={{ 
                margin: '0.5rem 0 0 0', 
                fontSize: '0.9rem',
                color: '#cbd5e1',
                lineHeight: '1.4'
              }}>
                Rusia, Siberia, Asia Central - Inaccesible al poder naval
              </p>
            </div>
          </Popup>
        </Polygon>

        {/* Europa del Este */}
        <Polygon
          positions={easternEuropeCoords}
          pathOptions={{ 
            color: '#eab308', 
            fillColor: '#eab308', 
            fillOpacity: 0.5,
            weight: 4
          }}
        >
          <Popup>
            <div style={{ 
              padding: '1rem', 
              background: '#1e293b', 
              borderRadius: '0.5rem',
              border: '2px solid #eab308',
              minWidth: '250px'
            }}>
              <h3 style={{ 
                margin: 0, 
                marginBottom: '0.75rem', 
                color: '#eab308',
                fontSize: '1.1rem',
                fontWeight: 'bold'
              }}>
                🟡 Europa del Este
              </h3>
              <p style={{ 
                margin: 0, 
                fontSize: '1rem',
                color: '#f1f5f9',
                fontWeight: '500',
                lineHeight: '1.4'
              }}>
                <strong>La Puerta al Heartland</strong>
              </p>
              <p style={{ 
                margin: '0.5rem 0 0 0', 
                fontSize: '0.9rem',
                color: '#cbd5e1',
                lineHeight: '1.4'
              }}>
                Polonia, Ucrania, Bielorrusia - Zona de conflicto histórico
              </p>
            </div>
          </Popup>
        </Polygon>
      </MapContainer>
    </div>
  );
};

export default HeartlandMap;
